import React from "react";
import ThemaLine from "./themaline";
import "./themalist.css";

class ThemaList extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            list: this.prepareList(props.list)
        };

        this.handleLineChange = this.handleLineChange.bind(this);
        this.handleLineDelete = this.handleLineDelete.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
    }


    componentDidUpdate(prevProps)
    {
        /*
         * Si la liste reçue par le parent change,
         * on resynchronise le composant.
         */
        if ((prevProps.list !== this.props.list) || (prevProps.conceptSet !== this.props.conceptSet))
        {
            this.setState({
                list: this.prepareList(this.props.list)
            });
        }
    }


    prepareList(list)
    {
        let result = Array.isArray(list)
            ? [...list]
            : [];

        /*
         * S'il n'y a aucune ligne,
         * on crée une ligne vide avec les valeurs par défaut.
         */
        if (result.length === 0)
        {
            result.push({
                iptccode: "",
                source: this.props.defaultImg || "HUMAN",
                confidence:
                    this.props.defaultConfidence == null
                        ? 1
                        : this.props.defaultConfidence
            });
        }

        /*
         * Respect de maxLines
         */
        if (this.props.maxLines != null)
        {
            result = result.slice(0, this.props.maxLines);
        }

        return result;
    }


    /*
     * Une ligne a changé.
     *
     * index = numéro de la ligne
     * value = nouveau code IPTC
     */
    handleLineChange(index, value)
    {
        const list = [...this.state.list];

        list[index] = {
            ...list[index],
            iptccode: value
        };

        this.setState({
            list: list
        });

        if (this.props.onChange)
            this.props.onChange(list);
    }


    /*
     * Suppression d'une ligne
     */
    handleLineDelete(index)
    {
        let list = [...this.state.list];

        list.splice(index, 1);

        /*
         * Si on supprime la dernière ligne,
         * on recrée une ligne vide.
         */
        if (list.length === 0)
        {
            list.push({
                iptccode: "",
                source: this.props.defaultImg || "HUMAN",
                confidence:
                    this.props.defaultConfidence == null
                        ? 1
                        : this.props.defaultConfidence
            });
        }

        this.setState({
            list: list
        });

        if (this.props.onChange)
            this.props.onChange(list);
    }


    /*
     * Ajout d'une nouvelle ligne
     */
    handleAdd()
    {
        if (this.state.list.length >= this.props.maxLines)
            return;

        const list = [
            ...this.state.list,
            {
                iptccode: "",
                source: this.props.defaultImg || "HUMAN",
                confidence:
                    this.props.defaultConfidence == null
                        ? 1
                        : this.props.defaultConfidence
            }
        ];

        this.setState({
            list: list
        });

        if (this.props.onChange)
            this.props.onChange(list);
    }


    render()
    {
        const list = this.state.list;

        return (
            <div className="thema-list">

                <div className="thema-list-header">

                    <div className="thema-header-image">
                    </div>

                    <div className="thema-header-iptc">
                        Thème
                    </div>

                    <div className="thema-header-confidence">
                        Conf.
                    </div>

                    <div className="thema-header-delete">
                    </div>

                </div>                

                {list.map((item, index) =>
                {
                    /*
                     * HUMAN => imgHuman
                     * tout le reste => imgIA
                     */
                    const image =
                        item.source === "HUMAN"
                            ? this.props.imgHuman
                            : this.props.imgIA;

                    return (
                        <ThemaLine
                            key={index}

                            data={this.props.conceptSet}

                            iptcCode={item.iptccode}

                            img={image}
                            source = {item.source}

                            confidence={item.confidence}

                            onChange={(value) =>
                                this.handleLineChange(
                                    index,
                                    value
                                )
                            }

                            onDelete={() =>
                                this.handleLineDelete(index)
                            }
                        />
                    );
                })}


                {list.length < this.props.maxLines && (
                    <button
                        type="button"
                        className="thema-list-add"
                        onClick={this.handleAdd}
                    >
                        +
                    </button>
                )}

            </div>
        );
    }
}


ThemaList.defaultProps = {
    list: [],
    maxLines: 3,
    defaultImg: "HUMAN",
    defaultConfidence: 1
};


export default ThemaList;